<template>
  <div class="card">
    <div class="card-top">
      <img v-if="cardinfo.icon" class="card-top-icon" :src="cardinfo.icon" />
      <div v-else class="card-top-default-icon"></div>
      <div class="card-top-text" :style="{ color: `${fontColor}` }">
        {{ cardinfo.text }}
      </div>
      <div v-if="showRightArrow" class="card-top-arrow"></div>
    </div>
    <template v-if="cardinfo.labelInfo">
      <div v-if="!Array.isArray(cardinfo.labelInfo)" class="card-text">
        {{ cardinfo.labelInfo }}
      </div>
      <div
        v-else-if="cardinfo.labelInfo.length"
        ref="promotions"
        class="card-promotions"
      >
        <div class="card-promotions-list">
          <div
            v-for="(item, index) in cardinfo.labelInfo"
            :key="index"
            class="card-promotions-list-item"
          >
            <div class="card-promotions-list-item-text">{{ item }}</div>
          </div>
        </div>
        <div
          v-if="showArrow"
          class="card-promotions-arrow"
          @click.stop.prevent="switchArrow"
        >
          <div :class="['card-promotions-arrow-item', promotionsArrow]"></div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'Card',
  props: {
    cardinfo: {
      type: Object,
      default: () => {},
    },
    fontColor: {
      type: String,
      default: '#222222',
    },
    showRightArrow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showArrow: false,
      promotionHeight: 0,
      labelHeight: 0,
      showAllLabel: false,
    }
  },
  computed: {
    promotionsArrow() {
      return this.showAllLabel ? 'up' : 'down'
    },
  },
  watch: {
    'cardinfo.labelInfo': function() {
      this.$nextTick(() => {
        this.adjustPromotion()
      })
    },
  },
  created() {},
  mounted() {
    this.adjustPromotion()
  },
  methods: {
    adjustPromotion() {
      this.promotionHeight = this.$refs?.promotions?.offsetHeight
      this.labelHeight =
        document.querySelector('.card-promotions-list-item')?.offsetHeight + 3
      if (this.promotionHeight > this.labelHeight) {
        this.showArrow = true
        this.$refs.promotions.firstElementChild.style.maxHeight = `${this.labelHeight}px`
      }
    },
    switchArrow() {
      if (!this.showAllLabel) {
        this.$refs.promotions.firstElementChild.style.maxHeight = `${2 *
          this.labelHeight}px`
        this.showAllLabel = true
      } else {
        this.$refs.promotions.firstElementChild.style.maxHeight = `${this.labelHeight}px`
        this.showAllLabel = false
      }
    },
  },
}
</script>
<style lang="less">
@import '../assets/variable.less';
.card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 260px;
  &-top {
    .flex-center(flex-start);
    &-icon {
      .size(18px);
    }
    &-default-icon {
      .size(18px);
      background: rgba(0, 0, 0, 0.06);
      border-radius: 3px;
    }
    &-text {
      margin-left: 8px;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #222222;
      text-align: center;
      line-height: 22px;
      .text-hide(234px);
    }
    &-arrow {
      margin-left: 6px;
      width: 5px;
      height: 8px;
      .bg-img(
        url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAYCAYAAAAlBadpAAAAAXNSR0IArs4c6QAAANdJREFUOBGd1EEOgjAQBVCmHqE7l7RbT+IdXKB74iX0BK4kLjyEnqbdeY46Q2gDoTQzbUIIybzfAdJprLVXY8yvbdt7CAEawQKCiPaTeTnnLgAQOBkK4XtW2GHYwO0AqBDBEwPOsxBWB+M71gakDzQFDLh7x+0gYQLSgAWWBqywJCCLuQGbmBNQxIWAo/f+o6igdhVx4dd9acPNtgswHZws5sDszly4whK4wFKYcA0ccS0krHCK3PDOPsOE4lI47E7xAe+s8RPrd1prmpQHvB44OXvu5KSAP0VZv3QOiYRzAAAAAElFTkSuQmCC)
      );
    }
  }
  &-text {
    .font-area(12px);
    margin-left: 26px;
    font-family: PingFangSC-Regular;
    color: #999999;
    letter-spacing: 0;
    text-align: left;
  }
  &-promotions {
    margin-top: 1px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-left: 26px;
    width: 207px;
    &-list {
      .flex-center(flex-start);
      width: 160px;
      flex-wrap: wrap;
      overflow-y: hidden;
      &-item {
        padding: 2px 0;
        margin: 2px 3px 0 1px;
        position: relative;
        height: 16px;
        &-text {
          .font-area(12px);
          transform: scale(0.833333333);
          font-family: PingFangSC-Medium;
          color: #ff6000;
          .text-hide(150px);
        }
      }
      &-item::before {
        .half-px();
        border: 1px solid #ffc49e;
        border-radius: 6px;
      }
    }
    &-arrow {
      width: 36px;
      height: 19px;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      &-item {
        margin-top: 8px;
        margin-right: 30px;
        width: 6px;
        height: 4px;
      }
    }
  }
}
.up {
  .bg-img(url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAAXNSR0IArs4c6QAAAHBJREFUCB1jYEACs2bNip03b54skhADI4wDlKz5//9/EJDPBcRu6enpj0ByTCACKukEZNowMTGVA+ldM2fOlAPJMQIly4E63YFsH6CubyDB2bNn+//796+Tk5PTGMTR3L9/PwtIAhnMnz9fYdu2bewARzcrXv+XlnsAAAAASUVORK5CYII=));
}
.down {
  .bg-img(
    url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAAXNSR0IArs4c6QAAAGBJREFUCB1jnDlz5lomJqZFqampGxmgACjGxcjIuJGZmTmeCShW+O/fv87Zs2f7g+RBkkBqCxAfTE5OfsYIFZQD0ruAJjUCFacCde9LS0trAcmBFSAp2geUXACTBIkTBADB1yFkbRGFVAAAAABJRU5ErkJggg==)
  );
}
</style>
